import { useQuery } from '@tanstack/react-query';
import { ApiError, apiFetch } from '../api/client';

export type Me = { classroomId: string; email: string; displayName: string; admin: boolean };

// 401 is the normal "not logged in" answer, so it resolves to null instead of an error.
async function fetchMe(): Promise<Me | null> {
  try {
    const response = await apiFetch('/api/auth/me');
    return (await response.json()) as Me;
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) return null;
    throw error;
  }
}

export function useMe() {
  return useQuery({ queryKey: ['me'], queryFn: fetchMe, staleTime: 60_000, retry: false });
}
